import React from 'react'
import Paper from '@material-ui/core/Paper';
import { DashboardApi } from '../../../api/dashboard_api'
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Divider from '@material-ui/core/Divider';

import {
    BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, AreaChart, Area, LineChart, Line,
    PieChart, Pie
} from 'recharts';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import NumberFormat from 'react-number-format';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';


const cardStyles = makeStyles({
    root: {
        minWidth: 275,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
});


const paperStyle = {
    marginTop: 100,
    paddingBottom: 50,
    paddingTop: 25,
    padingLeft: -50,
    padding: 20,
    width: '100%',
    textAlign: 'left',
    display: 'inline-block',
};



const COLOR_PALLETE = ["#264653",
    "#2a9d8f",
    "#e9c46a",
    "#f4a261",
    "#e76f51",
    "#3d405b",
    "#a8dadc",
    "#457b9d",
    "#1d3557"
];

export class ProductsDashboardView extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            top_month: [], // ['id', 'active','type', 'brand', 'model', 'stock', 'sold_items', 'voided_items', 'avg_items']
            worst_ever: [], // ['id', 'active','type', 'brand', 'model', 'stock', 'sold_items', 'voided_items', 'avg_items']
            type_monthly: [], // ['total', 'sold_items', 'voided_items', 'type']
            prods_without_stock: 0,
            active_products: 0,
            voided_products: 0,
            combos_sold_month: 0,
            total_combos: 0,
            stock_percentage: 0,
            new_products: 0,
            historical_type_monthly: []

        }
    }

    componentWillMount = () => {
        DashboardApi.getDashboardProduct()
            .then(response => {
                let data = response.data
                this.setState({prods_without_stock: data.prods_without_stock, type_monthly: data.type_monthly,
                               worst_ever: data.worst_ever, top_month: data.top_month, 'combos': data.combos,
                               active_products: data.active_products, voided_products: data.voided_products,
                               combos_sold_month: data.combos_sold_month, total_combos: data.total_combos,
                               stock_percentage: data.stock_percentage, new_products: data.new_products,
                               historical_type_monthly: data.historical_type_monthly
                               })
            }).catch(error=>{
                console.error(response)
            });

    }

    tableHeader = () =>{
      return (
        <TableHead>
          <TableRow>
            <TableCell  align="center"><b>Codigo</b></TableCell>
            <TableCell align="center"><b>Tipo</b></TableCell>
            <TableCell align="center"><b>Marca modelo</b></TableCell>
            <TableCell align="center"><b>Stock</b></TableCell>
            <TableCell align="center"><b>Unidades vendidas</b></TableCell>
            <TableCell align="center"><b>Unidades devueltas</b></TableCell>
            <TableCell align="center"><b>Promedio unidades por venta</b></TableCell>
          </TableRow>
        </TableHead>
      )
    }
    tableTop = () => {
      return (<div>
                <Typography variant="h4" component="h2" style={{ textAlign: 'center' }}>
                      Top mejores productos del mes
                </Typography>

                <Table>
                {this.tableHeader()}
                <TableBody>
                  {this.state.top_month.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell align="center">{row.id}</TableCell>
                      <TableCell align="center">{row.type}</TableCell>
                      <TableCell align="center">{row.brand} {row.model}</TableCell>
                      <TableCell align="right">{row.stock}</TableCell>
                      <TableCell align="right">{row.sold_items}</TableCell>
                      <TableCell align="right">{row.voided_items}</TableCell>
                      <TableCell align="right">{row.avg_items}</TableCell>
                    </TableRow>
                  ))}


                </TableBody>

                </Table>
          </div>)
    }
    tableWorst= () => {
      return (<div>
                <Typography variant="h4" component="h2" style={{ textAlign: 'center' }}>
                      Top peores productos
                </Typography>

                <Table>
                {this.tableHeader()}
                <TableBody>
                  {this.state.worst_ever.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell align="center">{row.id}</TableCell>
                      <TableCell align="center">{row.type}</TableCell>
                      <TableCell align="center">{row.brand} {row.model}</TableCell>
                      <TableCell align="right">{row.stock}</TableCell>
                      <TableCell align="right">{row.sold_items}</TableCell>
                      <TableCell align="right">{row.voided_items}</TableCell>
                      <TableCell align="right">{row.avg_items}</TableCell>
                    </TableRow>
                  ))}


                </TableBody>

                </Table>
          </div>)
    }

    render() {
        return (<div >
                  {this.state.isLoading &&
                      <div style={{ marginTop: 100 }} className="col-md-10 col-md-offset-1">
                          <CircularProgress
                              size={80}
                              color='primary'
                              thickness={3}
                              style={{ display: 'center' }} />
                      </div>
                  }
                  {!this.state.isLoading &&
                        <div>
                          <div class='col-md-12' style={{ marginLeft: -20}}>
                              <div class='col-md-1' />
                              <div class='col-md-3'  style={{marginTop: 20 }}>
                                  <Card className={cardStyles.root}>
                                      <CardContent>
                                          <Typography color="textSecondary" style={{ textAlign: 'center' }} gutterBottom>
                                              Productos disponibles
                                          </Typography>
                                          <Typography variant="h4" component="h2" style={{ textAlign: 'center' }}>
                                                  {this.state.active_products}
                                          </Typography>
                                          <Typography
                                              variant="body2"
                                              style={{ marginTop: 10, textAlign: 'center', color: this.state.stock_percentage >= 65? "green" : "red" }}
                                          >
                                          {this.state.stock_percentage}% con stock disponible
                                          </Typography>
                                      </CardContent>
                                  </Card>
                              </div>
                              <div class='col-md-1' />
                              <div class='col-md-3' style={{ marginTop: 20 }}>
                                  <Card className={cardStyles.root}>
                                      <CardContent>
                                          <Typography color="textSecondary" style={{ textAlign: 'center' }} gutterBottom>
                                              Productos sin stock
                                  </Typography>
                                          <Typography variant="h4" component="h2" style={{ textAlign: 'center' }}>
                                                {this.state.prods_without_stock}
                                          </Typography>

                                      </CardContent>
                                  </Card>
                              </div>
                              <div class='col-md-1' />
                              <div class='col-md-2' style={{ marginTop: 20 }}>
                                  <Card className={cardStyles.root} >
                                      <CardContent>
                                          <Typography color="textSecondary" style={{ textAlign: 'center' }} gutterBottom>
                                              Productos devueltos
                                  </Typography>
                                          <Typography variant="h4" style={{ textAlign: 'center' }}>
                                              {this.state.voided_products}
                                          </Typography>
                                          <Typography
                                              variant="body3"
                                              style={{ color: 'grey',  textAlign: 'center', marginLeft: 20  }}
                                          >
                                          Mes actual
                                          </Typography>
                                      </CardContent>
                                  </Card>
                              </div>
                          </div>
                          <div class='col-md-12' style={{ marginLeft: -20}}>
                              <div class='col-md-1' />
                              <div class='col-md-3' style={{marginTop: 20 }}>
                                  <Card className={cardStyles.root}>
                                      <CardContent>
                                          <Typography color="textSecondary" style={{ textAlign: 'center' }} gutterBottom>
                                              Combos activos
                                          </Typography>
                                          <Typography variant="h4" component="h2" style={{ textAlign: 'center' }}>
                                                  {this.state.total_combos}
                                          </Typography>
                                      </CardContent>
                                  </Card>
                              </div>
                              <div class='col-md-1' />
                              <div class='col-md-3' style={{ marginTop: 20 }}>
                                  <Card className={cardStyles.root}>
                                      <CardContent>
                                          <Typography color="textSecondary" style={{ textAlign: 'center' }} gutterBottom>
                                             Combos vendidos
                                  </Typography>
                                          <Typography variant="h4" component="h2" style={{ textAlign: 'center' }}>
                                                  {this.state.combos_sold_month}
                                          </Typography>
                                          <Typography
                                              variant="body3"
                                              style={{ color: 'grey',  textAlign: 'center', marginLeft: 65  }}
                                          >
                                          Mes actual
                                          </Typography>
                                      </CardContent>
                                  </Card>
                              </div>
                              <div class='col-md-1' />
                              <div class='col-md-2' style={{ marginTop: 20 }}>
                                  <Card className={cardStyles.root} >
                                      <CardContent>
                                          <Typography color="textSecondary" style={{ textAlign: 'center' }} gutterBottom>
                                              Productos nuevos
                                  </Typography>
                                          <Typography variant="h4" component="h2" style={{ textAlign: 'center' }}>
                                              {this.state.new_products}
                                          </Typography>
                                          <Typography
                                              variant="body3"
                                              style={{ color: 'grey',  textAlign: 'center', marginLeft: 20  }}
                                          >
                                          Mes actual
                                          </Typography>
                                      </CardContent>
                                  </Card>
                              </div>
                              <div class='col-md-6' style={{marginTop:40}}>
                              <Typography variant="body2" style={{ textAlign: 'center' }}>
                                  Ventas por tipo (mes)
                              </Typography>
                              </div>
                              <div class='col-md-6' style={{marginTop:42}}>
                              <Typography variant="body2" component="h2" style={{ textAlign: 'center' }}>
                                  Ventas por tipo (historico)
                              </Typography>
                              </div>
                              <div class='col-md-12' >
                                  {!this.state.isLoading && <div style={{ marginLeft: 110, martinTop: 250, borderColor: 'red' }}>
                                      <PieChart width={850} height={400}>
                                          <Pie isAnimationActive={true} data={this.state.type_monthly} cx={130} cy={150} outerRadius={70} fill="grey" label />
                                          <Pie isAnimationActive={true} data={this.state.historical_type_monthly} cx={650} cy={150} outerRadius={70} fill="grey" label />
                                          <p>Total de ventas por tipo</p>
                                           <Tooltip />
                                      </PieChart>
                                  </div>}
                              </div>

                              <div class='col-md-12' >
                                  {!this.state.isLoading &&
                                    this.tableTop()
                                  }
                                </div>
                                <div class='col-md-12' style={{marginTop: 20}} >
                                    {!this.state.isLoading &&
                                      this.tableWorst()
                                    }
                                </div>

                          </div>

                    <br />
                    <br />
                    <br />

                </div>}
                </div>

        )
    }
}

export default ProductsDashboardView



// WEBPACK FOOTER //
// ./src/components/Admin/Dashboard/ProductDashboardView.js